/**
 * News grid
 */

// Import extend function.
import Component from '../../js/core/component.js';
import keycodes from '../../js/utilities/keycodes/u-keycodes.js';
import focusableElements from '../../js/utilities/focusable-elements/u-focusable-elements.js';
import breakpoint from '../../js/utilities/breakpoint/u-breakpoint.js';
import getDataSettings from '../../js/utilities/get-data-settings/u-get-data-settings.js';

class NewsGrid extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false,
			element: null,
			columns: 2,
			selectors: {
				item: '.c-news-grid__item'
			}
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		this.element = this.settings.element;
		this.items = this.element.querySelectorAll(this.settings.selectors.item);
		this.columns = [];
		this.inited = false;
		this.keypressHandler = this._fixTab.bind(this);
	}

	_createColumns () {
		this.element.classList.add('o-grid');

		this.items.forEach((item, i) => {
			item.height = item.clientHeight;
			item.setAttribute('data-no', i);
			item.remove();
		});

		for (let i = 0; i < this.settings.columns; i++) {
			this.columns[i] = document.createElement('div');
			this.columns[i].classList.add('o-grid__column');
			this.columns[i].setAttribute('data-size', 'sm:12 md:' + (12 / this.settings.columns));
			this.element.appendChild(this.columns[i]);
		}

		this.element.addEventListener('keydown', this.keypressHandler);

	}

	_destroyColumns () {
		this.columns.forEach(column => {
			column.remove();
		});

		this.columns = [];

		this.element.classList.remove('o-grid');

		this.element.removeEventListener('keydown', this.keypressHandler);
	}

	_insertItems () {

		this.items.forEach(item => {
			let column = this._getColumn(item);

			if (column) {
				column.appendChild(item);
			}

		});
	}

	_restoreItems () {
		this.items.forEach(item => {
			this.element.appendChild(item);
		});
	}

	_getColumn () {
		let column = null;

		for (let i in this.columns) {
			if (this.columns[i]) {
				let c = this.columns[i];

				if (column === null || c.clientHeight < column.clientHeight) {
					column = c;
				}

				/* let next = this.columns[parseInt(i)+1] || this.columns[0];

				if (c.clientHeight === 0) {
					return c;
				}

				if ((next.clientHeight + item.height) <= (c.clientHeight + item.height)) {
					return next;
				} */
			}
		}

		return column;

	}

	_fixTab (e) {
		if (e.which === keycodes.TAB) {

			if (e.shiftKey) {
				let prevItem = this._getPrevFocusableItem();

				if (prevItem) {
					prevItem.focus();
					e.preventDefault();
				}
			}
			else {
				let nextItem = this._getNextFocusableItem();

				if (nextItem) {
					nextItem.focus();
					e.preventDefault();
				}
			}
		}
	}

	_getCurrentFocusedItem () {
		let currentFocus = document.activeElement;
		return currentFocus.closest(this.settings.selectors.item);
	}

	_getNextFocusableItem () {
		let current = this._getCurrentFocusedItem();

		let i = 0;
		let done = false;

		while (i <= this.items.length && done === false) {
			let nextItemIndex = parseInt(current.getAttribute('data-no')) + 1;
			let nextItem = this.element.querySelector(this.settings.selectors.item + `[data-no="${nextItemIndex}"]`);
			if (!nextItem) {
				return false;
			}

			let nextFocusable = nextItem.querySelector(focusableElements);

			if (nextFocusable) {
				return nextFocusable;
			}
			i++;
		}

		return false;
	}

	_getPrevFocusableItem () {
		let current = this._getCurrentFocusedItem();

		let i = 0;
		let done = false;

		while (i <= this.items.length && done === false) {
			let prevItemIndex = parseInt(current.getAttribute('data-no')) - 1;
			let prevItem = this.element.querySelector(this.settings.selectors.item + `[data-no="${prevItemIndex}"]`);
			if (!prevItem) {
				return false;
			}

			let prevFocusable = prevItem.querySelector(focusableElements);

			if (prevFocusable) {
				return prevFocusable;
			}
			i++;
		}

		return false;
	}

	init () {
		if (this.inited) {
			return;
		}

		this._createColumns();
		this._insertItems();

		this.inited = true;
	}

	destroy () {
		this._destroyColumns();
		this._restoreItems();

		this.inited = false;
	}
}

document.addEventListener('newcontent', (e) => {
	e.target.querySelectorAll('.c-news-grid').forEach((newsGrid) => {

		let settings = getDataSettings(newsGrid, {
			debug: false,
			element: newsGrid
		});

		newsGrid.newsGrid = new NewsGrid(settings);

		breakpoint('only screen and (min-width:769px)', {
			enter: () => {
				newsGrid.newsGrid.init();
			},
			exit: () => {
				newsGrid.newsGrid.destroy();
			}
		});
	});
});

export default NewsGrid;



// WEBPACK FOOTER //
// ./components/news-grid/c-news-grid.js